import React from 'react';
import { HStack } from 'native-base';
import { Image } from 'expo-image';
import { CakeIcon } from 'react-native-heroicons/solid';

import { BasicsTag } from '../../tags/basics-tag/basics-tag';
import { User } from '@breakroom-nx/classes';
import { theme } from '@breakroom-nx/assets';
import { AppData } from '@breakroom-nx/helpers';

import logoImage from '../../../../assets/src/images/icon.webp';

export interface ProfileTagsProps {
  readonly user: User;
}

export function ProfileTags({ user }: ProfileTagsProps) {
  return (
    <HStack
      direction="row"
      flexWrap="wrap"
      justifyContent={'center'}
      alignItems={'center'}
      space={'6px'}
      fontSize={11}
    >
      {user.geoCode && (
        <BasicsTag
          icon={<span className={`fi fi-${user.geoCode.toLowerCase()}`}></span>}
          text={user.getLocation()}
        />
      )}

      {user.dateOfBirth && (
        <BasicsTag
          icon={<CakeIcon color={theme.colors.primary[400]} size={15} />}
          text={`${user.getAge()}`}
        />
      )}

      {user.isTeamMember && (
        <BasicsTag
          icon={
            <Image
              source={logoImage}
              cachePolicy={'memory-disk'}
              accessibilityLabel={`${AppData.APP_NAME} logo`}
              contentFit={'contain'}
              style={{
                height: '15px',
                width: '15px',
              }}
            />
          }
          text={`Team Member`}
        />
      )}
    </HStack>
  );
}

export default ProfileTags;
